import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

type RadioProps = {
  checked?: boolean
  className?: string
}

const Radio: React.FC<RadioProps> = ({ checked, className }) => {
  const classes = useStyles({ checked })

  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.button} />
    </div>
  )
}

export default Radio
